export default "__VITE_ASSET__1387afdf__"